import { apiClient } from '@/services/api';

export const pushOpensService = {
  /**
   * POST /api/v1/notification_deliveries/:id/opened — log that the user tapped
   * this push.
   *
   * The id comes from the notification's own payload: the backend merges
   * `delivery_id` into `data` at send time (see SendPushNotificationJob), so a
   * tap resolves to the exact delivery row that produced it.
   *
   * "Opened" means tapped, and only tapped. iOS tells us nothing about someone
   * who reads the banner and opens the app from the home screen — they count as
   * un-opened. Same ceiling as reminders.logNudge, where iOS won't say whether
   * the composer was sent or cancelled.
   *
   * Returns void: the endpoint answers 204 and the caller fire-and-forgets.
   */
  async logOpen(deliveryId: number): Promise<void> {
    await apiClient.post<void>(`/api/v1/notification_deliveries/${deliveryId}/opened`, undefined, {
      // Nobody asked for this request. If the token turns out to be stale, the
      // user should find out when they next do something real — not get signed
      // out by an analytics ping fired on a notification tap.
      suppressUnauthenticated: true,
    });
  },
};
